import { ShiftType } from '@ms/timesheets/dist/models/shift-type';
import { IOnlineApprovalTimeEntry } from '../models/online-approval-time-entry.model';
import { PendingTimesheet } from '../models/pending-timesheets.model';
import { TimeSheetLogic } from '@ms/timesheets/dist/logic/time-sheet.logic';

export class CalculateHoursLogic {
    static calculateTimesheetTotals(
        updatedTimeEntry: IOnlineApprovalTimeEntry,
        timeEntries: IOnlineApprovalTimeEntry[],
        timesheet: PendingTimesheet,
    ): PendingTimesheet {
        const newTimeEntries = timeEntries.filter(
            (te: IOnlineApprovalTimeEntry) => te.timesheetId === timesheet?.timesheetId,
        );

        const index = newTimeEntries?.findIndex((te: IOnlineApprovalTimeEntry) => te.id === updatedTimeEntry?.id);

        if (index !== -1) {
            newTimeEntries[index] = updatedTimeEntry;
        }

        const newTotalHours = TimeSheetLogic.calcTotalHours(newTimeEntries as IOnlineApprovalTimeEntry[]);
        const newTotals = TimeSheetLogic.calcTotals(newTimeEntries as IOnlineApprovalTimeEntry[]);

        // Add ShiftType.Charge
        newTotals[ShiftType.Charge] = TimeSheetLogic.calcHours(ShiftType.Charge, newTimeEntries);

        const updatedTimeSheet = { ...timesheet } as PendingTimesheet;

        updatedTimeSheet.totalHours = newTotalHours;
        updatedTimeSheet.regularHours = newTotals[ShiftType.Regular];
        updatedTimeSheet.onCallHours = newTotals[ShiftType.OnCall] === undefined ? 0 : newTotals[ShiftType.OnCall];
        updatedTimeSheet.chargeHours = newTotals[ShiftType.Charge] === undefined ? 0 : newTotals[ShiftType.Charge];
        updatedTimeSheet.callbackHours =
            newTotals[ShiftType.Callback] === undefined ? 0 : newTotals[ShiftType.Callback];

        return updatedTimeSheet;
    }
}
